import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { getChallengeSelectionPreview } from 'src/services/payment.service';
import { setChallengeSelectionPreview } from 'src/store/signup';
import { isUserFromUK } from 'src/lib/utils';

export const useChallengeSelectionPreview = (shouldFetch: boolean) => {
  const dispatch = useAppDispatch();
  const challengeSelectionPreview = useAppSelector(
    state => state.signUp.challengeSelectionPreview
  );

  useEffect(() => {
    if (shouldFetch && !challengeSelectionPreview) {
      getChallengeSelectionPreview(isUserFromUK() ? 'gbp' : undefined)
        .then(res => {
          if (res?.data?.preview) {
            dispatch(setChallengeSelectionPreview(res.data.preview));
          }
        })
        .catch(err => {
          console.error('Error fetching challenge selection preview', err);
        });
    }
  }, [shouldFetch, challengeSelectionPreview, dispatch]);
};
